module.exports = __webpack_public_path__ + "img/RecycleBin.f565b72e.png";